import TH_BsButton from '_tradeholding/js/Classes/BsButton.js';

let BsButton = TH_BsButton;

export default BsButton;